module.exports = __webpack_public_path__ + "img/product-brand.7c3a14a5.svg";